import { ca } from '@cian/analytics';

export function trackListingLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'click_listing_jk',
    label: 'more_jk',
    useLastProducts: true,
  });
}
